"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserColors = exports.DEFAULT_EXPERT_COLOR = void 0;
const chroma_js_1 = __importDefault(require("chroma-js"));
const color_1 = require("./color");
exports.DEFAULT_EXPERT_COLOR = '#1890FF';
const USER_COLORS = {
    stencil: {
        pen: '#000000',
        highlighter: (0, color_1.convertToHighlighter)('#000000'),
        sticky: (0, color_1.convertToSticky)('#000000'),
    },
    placeholder: {
        pen: '#E6E6E6',
        highlighter: (0, color_1.convertToHighlighter)('#E6E6E6'),
        sticky: (0, color_1.convertToSticky)('#E6E6E6'),
    },
    0: {
        pen: '#000000',
        highlighter: (0, color_1.convertToHighlighter)('yellow'),
        sticky: (0, color_1.convertToSticky)('yellow'),
    },
    1: {
        pen: exports.DEFAULT_EXPERT_COLOR,
        highlighter: (0, color_1.convertToHighlighter)(exports.DEFAULT_EXPERT_COLOR),
        sticky: (0, color_1.convertToSticky)(exports.DEFAULT_EXPERT_COLOR),
    },
    2: {
        pen: '#BB59FF',
        highlighter: (0, color_1.convertToHighlighter)('#BB59FF'),
        sticky: (0, color_1.convertToSticky)('#BB59FF'),
    },
    3: {
        pen: '#FF6B35',
        highlighter: (0, color_1.convertToHighlighter)('#FF6B35'),
        sticky: (0, color_1.convertToSticky)('#FF6B35'),
    },
    4: {
        pen: '#01DAAD',
        highlighter: (0, color_1.convertToHighlighter)('#01DAAD'),
        sticky: (0, color_1.convertToSticky)('#01DAAD'),
    },
    5: {
        pen: '#21C2FD',
        highlighter: (0, color_1.convertToHighlighter)('#21C2FD'),
        sticky: (0, color_1.convertToSticky)('#21C2FD'),
    },
    6: {
        pen: '#FF3392',
        highlighter: (0, color_1.convertToHighlighter)('#FF3392'),
        sticky: (0, color_1.convertToSticky)('#FF3392'),
    },
    7: {
        pen: '#666A75',
        highlighter: (0, color_1.convertToHighlighter)('#666A75'),
        sticky: (0, color_1.convertToSticky)('#666A75'),
    },
    8: {
        pen: '#7371FC',
        highlighter: (0, color_1.convertToHighlighter)('#7371FC'),
        sticky: (0, color_1.convertToSticky)('#7371FC'),
    },
    9: {
        pen: '#2FC675',
        highlighter: (0, color_1.convertToHighlighter)('#2FC675'),
        sticky: (0, color_1.convertToSticky)('#2FC675'),
    },
    10: {
        pen: '#9296A0',
        highlighter: (0, color_1.convertToHighlighter)('#9296A0'),
        sticky: (0, color_1.convertToSticky)('#9296A0'),
    },
    11: {
        pen: '#F54CD1',
        highlighter: (0, color_1.convertToHighlighter)('#F54CD1'),
        sticky: (0, color_1.convertToSticky)('#F54CD1'),
    },
    12: {
        pen: '#FA843F',
        highlighter: (0, color_1.convertToHighlighter)('#FA843F'),
        sticky: (0, color_1.convertToSticky)('#FA843F'),
    },
    13: {
        pen: '#27AE60',
        highlighter: (0, color_1.convertToHighlighter)('#27AE60'),
        sticky: (0, color_1.convertToSticky)('#27AE60'),
    },
    14: {
        pen: '#D35400',
        highlighter: (0, color_1.convertToHighlighter)('#D35400'),
        sticky: (0, color_1.convertToSticky)('#D35400'),
    },
    15: {
        pen: '#2980B9',
        highlighter: (0, color_1.convertToHighlighter)('#2980B9'),
        sticky: (0, color_1.convertToSticky)('#2980B9'),
    },
    16: {
        pen: '#F39C12',
        highlighter: (0, color_1.convertToHighlighter)('#F39C12'),
        sticky: (0, color_1.convertToSticky)('#F39C12'),
    },
    17: {
        pen: '#2C3E50',
        highlighter: (0, color_1.convertToHighlighter)('#2C3E50'),
        sticky: (0, color_1.convertToSticky)('#2C3E50'),
    },
};
let EXPERT_COLOR = '';
let SIGNIFICANT_USER_COLORS = [];
const getUserColors = (colorIndex, expertColor) => {
    if (typeof colorIndex === 'string') {
        if (colorIndex in USER_COLORS) {
            return USER_COLORS[colorIndex];
        }
        else {
            return USER_COLORS[0];
        }
    }
    else if (typeof colorIndex === 'number') {
        if (colorIndex === 0) {
            return USER_COLORS[0];
        }
        else if ((expertColor ?? '') !== '') {
            if (colorIndex === 1) {
                return {
                    pen: expertColor,
                    highlighter: (0, color_1.convertToHighlighter)(expertColor),
                    sticky: (0, color_1.convertToSticky)(expertColor),
                };
            }
            if (EXPERT_COLOR !== expertColor) {
                EXPERT_COLOR = expertColor;
                SIGNIFICANT_USER_COLORS = [];
                for (let i = 2; i < 18; i++) {
                    if (chroma_js_1.default.deltaE(EXPERT_COLOR, USER_COLORS[i].pen) > 20) {
                        SIGNIFICANT_USER_COLORS.push(USER_COLORS[i]);
                    }
                }
            }
            return SIGNIFICANT_USER_COLORS[(colorIndex - 2) % SIGNIFICANT_USER_COLORS.length];
        }
        return USER_COLORS[((colorIndex - 1) % 16) + 1];
    }
    return USER_COLORS[0];
};
exports.getUserColors = getUserColors;
